<div>
	<p>
		<span translate>We use cookies to improve the user experience</span>
		<span class="ml-1">
			<a
				[routerLink]="getRouterLink(ROUTE_PATH.LEGAL)"
				[queryParams]="{
					page: 'privacy',
					lng: languageName
				}"
				translate
				>More information.</a
			>
		</span>
	</p>
	<div>
		<p class="m-0" (click)="onConsentCookies($event)" translate>Hide</p>
	</div>
</div>
